import { ReactNode } from "react"

type NumberButtonProps = {
  disabled: boolean
  onClick: () => void
  children: ReactNode
}

const NumberButton = ({ disabled, onClick, children }: NumberButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      tabIndex={-1}
      className="size-full p-0 text-xl hover:bg-gray-200"
    >
      {children}
    </button>
  )
}

export type NumberButtonsProps = {
  value: number
  onChange: (value: number) => void
  min: number
  max: number
}

export const NumberButtons = ({ value, onChange, min, max }: NumberButtonsProps) => {
  const increment = () => onChange(value + 1)
  const decrement = () => onChange(value - 1)

  return (
    <div className="grid grid-cols-3 items-center overflow-hidden rounded-md border bg-gray-50 hover:bg-gray-100 has-focus:border-current has-focus:ring-0">
      <NumberButton onClick={decrement} disabled={value <= min}>
        -
      </NumberButton>

      <input
        type="number"
        value={value}
        onChange={(event) => onChange(+event.target.value || 0)}
        min={min}
        max={max}
        className="h-10 w-7.5 [appearance:textfield] text-center text-sm outline-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      />

      <NumberButton onClick={increment} disabled={value >= max}>
        +
      </NumberButton>
    </div>
  )
}
